import { useNavigation } from '@/hooks/useNavigation';
import { Button } from '@nextui-org/react';

const NotFound = ({
  title = '404',
  description = 'Page not found',
  action,
}: {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}) => {
  const { navigateToHome } = useNavigation();

  return (
    <div className="flex gap-2 flex-col items-center justify-center min-h-screen px-4">
      <h1 className="text-xl font-bold text-gray-900 dark:text-white">
        {title}
      </h1>
      <p className="text-lg text-gray-600 dark:text-gray-400">{description}</p>
      {action ? (
        action
      ) : (
        <Button
          onClick={() => navigateToHome({ replace: true })}
          color="primary"
          variant="solid"
        >
          Go back home
        </Button>
      )}
    </div>
  );
};

export default NotFound;
